import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const peopleCardDefaultVariants = {}
const peopleCardCompoundVariants = []

const peopleCardSlotNames = [
  [
    "root",
    "PeopleCard__root"
  ],
  [
    "title",
    "PeopleCard__title"
  ],
  [
    "description",
    "PeopleCard__description"
  ],
  [
    "image",
    "PeopleCard__image"
  ],
  [
    "wrapper",
    "PeopleCard__wrapper"
  ],
  [
    "fallback",
    "PeopleCard__fallback"
  ]
]
const peopleCardSlotFns = /* @__PURE__ */ peopleCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, peopleCardDefaultVariants, getSlotCompoundVariant(peopleCardCompoundVariants, slotName))])

const peopleCardFn = memo((props = {}) => {
  return Object.fromEntries(peopleCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const peopleCardVariantKeys = []
const getVariantProps = (variants) => ({ ...peopleCardDefaultVariants, ...compact(variants) })

export const peopleCard = /* @__PURE__ */ Object.assign(peopleCardFn, {
  __recipe__: false,
  __name__: 'peopleCard',
  raw: (props) => props,
  variantKeys: peopleCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, peopleCardVariantKeys)
  },
  getVariantProps
})